// extracted by mini-css-extract-plugin
export default {"NotificationItem":"styles_NotificationItem__2uYG6","container":"styles_container__C1fJd","description":"styles_description__0y4m1"};